import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";

const HeaderTitle = ({
  isSmallScreen,
  setIsDrawerOpen,
  isDrawerOpen,
  title,
  ACM,
  typeOfUser,
  location,
  user,
}) => {
  return (
    <>
      {isSmallScreen && (
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Menu">
            <IconButton onClick={() => setIsDrawerOpen(!isDrawerOpen)}>
              <MenuIcon sx={{ color: "white" }} />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="h5"
          component="div"
          sx={{
            ml: 2,
            flexGrow: 1,
            fontFamily: "Lato",
            color: "var(--clr-theme-gray-dark)",
          }}
        >
          {title}
        </Typography>
        {/* Welcome message for teachers on dashboard */}
        {/* {ACM[typeOfUser]?.isTeacher && location.pathname === "/" && (
          <Typography
            variant="h6"
            component="div"
            sx={{
              ml: 2,
              flexGrow: 1,
              fontFamily: "Lato",
              fontWeight: 700,
              color: "var(--clr-mindly-black)",
              marginTop: 1,
            }}
          >
            Welcome, {user?.fullname || user?.displayName}
          </Typography>
        )} */}
      </Box>
    </>
  );
};

export default HeaderTitle;
